var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLlkc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 60,
    viewBox: "0 0 180 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1818 40.1932C55.7045 41.7273 54.6477 42.8523 53.625 43.9773C53.4886 44.1136 53.3182 44.25 53.1477 44.2841C52.4659 44.3182 52.1591 44.5909 52.3295 45.3068C52.3977 45.5455 52.1932 45.75 51.9205 45.75C51.3409 45.7159 51.1023 46.1932 50.8977 46.5682C50.4205 47.3864 49.875 48.1364 49.2614 48.8523C49.0909 49.0568 48.9205 49.2955 48.6477 49.3636C48.375 49.4318 48.1023 49.5341 48.0682 49.0568C48 48.375 47.5568 48.2045 46.9432 48.2386C45.2045 48.3409 44.8295 51.1023 39.2727 51.9205C39.2727 52.7386 38.7614 53.0114 38.4886 53.1477C35.2841 54.4432 34.0568 54.8182 30.6477 53.625C29.3523 53.1818 28.3636 54.0682 26.4886 53.7273C24.9886 53.4545 24.3068 54.1023 22.9091 53.2841C22.0909 52.8068 21.1023 52.5682 20.1818 52.3295C18.8182 51.9886 19.125 50.9659 16.2273 50.9318C16.0909 50.9318 15.8864 50.8295 15.8182 50.7273C15.3409 49.9432 14.3182 49.7386 13.875 48.9205C13.7727 48.7159 13.5341 48.5795 13.3295 48.4773C12.2727 47.8977 11.5909 47.0114 10.9091 46.0568C10.8068 45.9205 10.7727 45.7841 10.6023 45.75C10.0568 45.6818 9.95455 45.2727 9.92045 44.8295C9.88636 44.5909 9.85227 44.3523 9.61364 44.25C8.72727 43.9091 8.52273 43.0909 8.28409 42.3068C8.07955 41.6932 7.80682 41.1818 7.36364 40.7045C6.54545 39.7841 6.85227 38.5227 6.71591 37.2955C6.61364 36.2727 5.55682 35.4205 5.38636 34.3977C5.14773 33.1023 5.625 33.1705 5.69318 31.8068C5.82955 30.0341 5.42045 29.4205 5.42045 29.0114C5.38636 28.2273 5.28409 27.6136 5.52273 26.8977C5.72727 26.3182 5.82955 25.7727 5.79545 25.1932C5.76136 24.8182 5.82955 24.5455 6.03409 24.2045C6.47727 23.4886 6.17045 22.9773 6.17045 22.9773C6.17045 22.9773 7.125 22.3636 7.05682 19.9091C7.02273 18.5455 8.86364 17.5227 9 16.2614C9.23864 14.0455 11.6932 12.9545 11.7614 11.7614C11.8977 9 14.9659 10.0568 14.9318 8.65909C15.375 7.67045 15.9205 8.42045 16.5682 7.94318C17.4205 7.26136 18 5.55682 18.5455 5.04545C19.2273 4.43182 19.2273 5.31818 19.9432 4.70455C20.8977 3.88636 22.0227 3.30682 23.2159 3.30682C24 3.30682 25.0227 2.93182 25.1591 2.48864C25.4659 1.46591 28.7386 1.60227 29.8295 1.60227C30.5114 1.60227 31.6023 2.01136 32.25 1.53409C32.8977 1.02273 33.4432 1.63636 33.9545 1.22727C34.2955 0.954545 36.8864 1.36364 37.5682 1.53409C50.1136 4.875 59.4205 16.3295 59.4205 29.9318C59.4205 31.0909 59.3864 32.25 59.2159 33.375C58.875 35.6591 58.0227 35.4886 57.3409 38.3864C57.6477 39.4432 56.3182 39.75 56.1818 40.1932ZM30 0C13.4659 0 0 13.4659 0 30C0 46.5341 13.4659 60 30 60C46.5341 60 60 46.5341 60 30C60 13.4659 46.5341 0 30 0Z",
    fill: "#C09B56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2159 18.5794L21 10.3635L20.3523 11.0453L28.5341 19.2272L29.2159 18.5794Z",
    fill: "#C09B56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3523 38.4204L40.2954 46.3636L40.9432 45.7159L33 37.7727L32.3523 38.4204Z",
    fill: "#C09B56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0455 20.3521L28.5341 37.8408L30.75 35.6249L13.2273 18.1362L11.0455 20.3521Z",
    fill: "#C09B56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9318 19.2273L30.75 21.4432L48.2386 38.9318L50.4546 36.75L32.9318 19.2273Z",
    fill: "#C09B56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7614 30.0681L12.5455 38.284L13.2273 38.9317L21.4091 30.7499L20.7614 30.0681Z",
    fill: "#5A652A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3182 46.0568L22.5341 48.2386L40.0568 30.75L37.8409 28.5341L20.3182 46.0568Z",
    fill: "#5A652A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2386 18.1362L40.0568 26.3521L40.7045 26.9999L48.8863 18.784L48.2386 18.1362Z",
    fill: "#5A652A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1478 11.0455L38.9318 8.82959L21.4432 26.3182L23.625 28.5341L41.1478 11.0455Z",
    fill: "#5A652A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1023 10.3977H69.9204V17.0795H74.1477V17.8636H69.1023V10.3977Z",
    fill: "#5A652A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.6818 15.1364L79.9773 11.3182L78.2727 15.1364H81.6818ZM79.6023 10.3296H80.3864L83.7955 17.8637H82.875L81.9886 15.8864H77.9318L77.0455 17.8637H76.1932L79.6023 10.3296Z",
    fill: "#5A652A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.3977 11.1477H85.9091V10.3977H91.7727V11.1477H89.25V17.8636H88.3977V11.1477Z",
    fill: "#5A652A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.8523 10.3977H94.8068L97.4659 16.8068L100.125 10.3977H101.045L97.8068 17.8977H97.0568L93.8523 10.3977Z",
    fill: "#5A652A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.739 10.3977H104.557V17.8636H103.739V10.3977Z",
    fill: "#5A652A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.182 16.6363L107.795 16.125C108.239 16.8068 108.716 17.1818 109.5 17.1818C110.352 17.1818 110.966 16.5682 110.966 15.375V10.3977H111.818V15.4091C111.818 16.2954 111.58 16.9432 111.136 17.3863C110.727 17.7954 110.148 18 109.5 18C108.375 17.9659 107.659 17.4204 107.182 16.6363Z",
    fill: "#5A652A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.795 15.1364L118.091 11.3182L116.386 15.1364H119.795ZM117.716 10.3296H118.5L121.909 17.8637H121.023L120.136 15.8864H116.08L115.193 17.8637H114.341L117.716 10.3296Z",
    fill: "#5A652A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.057 16.7728L124.568 16.1592C125.352 16.8751 126.102 17.216 127.125 17.216C128.114 17.216 128.795 16.6706 128.795 15.9547V15.9206C128.795 15.2387 128.42 14.8297 126.852 14.4887C125.148 14.1137 124.329 13.5683 124.329 12.341V12.3069C124.329 11.1478 125.352 10.2615 126.784 10.2615C127.875 10.2615 128.659 10.5683 129.409 11.1819L128.932 11.8297C128.25 11.2501 127.534 11.0115 126.784 11.0115C125.795 11.0115 125.182 11.5569 125.182 12.2047V12.2728C125.182 12.9887 125.557 13.3637 127.227 13.7387C128.898 14.1137 129.648 14.7274 129.648 15.8524V15.8865C129.648 17.1819 128.591 18.0001 127.091 18.0001C125.932 17.966 124.943 17.5569 124.057 16.7728Z",
    fill: "#5A652A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.5909 31.0228L96.1023 30.4092C96.8864 31.1251 97.6364 31.466 98.6591 31.466C99.6478 31.466 100.33 30.9206 100.33 30.2047V30.1706C100.33 29.4887 99.9546 29.0797 98.3864 28.7387C96.6819 28.3637 95.8637 27.8183 95.8637 26.591V26.5569C95.8637 25.3978 96.8864 24.5115 98.3182 24.5115C99.4091 24.5115 100.193 24.8183 100.943 25.4319L100.466 26.0797C99.7841 25.5001 99.0682 25.2615 98.3182 25.2615C97.3296 25.2615 96.7159 25.8069 96.7159 26.4547V26.4887C96.7159 27.2047 97.0909 27.5797 98.7614 27.9547C100.432 28.3297 101.182 28.9433 101.182 30.0683V30.1024C101.182 31.3978 100.125 32.216 98.625 32.216C97.4659 32.216 96.4773 31.8069 95.5909 31.0228Z",
    fill: "#5A652A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.727 10.3977H138.545V17.0795H142.773V17.8636H137.727V10.3977Z",
    fill: "#5A652A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.307 15.1364L148.602 11.3182L146.898 15.1364H150.307ZM148.227 10.3296H149.011L152.42 17.8637H151.5L150.614 15.8864H146.591L145.705 17.8637H144.852L148.227 10.3296Z",
    fill: "#5A652A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.943 14.7272V10.3977H155.795V14.6591C155.795 16.2613 156.648 17.1818 158.079 17.1818C159.443 17.1818 160.329 16.3636 160.329 14.7272V10.3977H161.182V14.6591C161.182 16.8409 159.92 17.9659 158.045 17.9659C156.204 17.9659 154.943 16.8409 154.943 14.7272Z",
    fill: "#5A652A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.318 10.3977H165.136V14.8295L169.432 10.3977H170.523L167.318 13.6363L170.659 17.8636H169.602L166.739 14.25L165.136 15.8523V17.8636H164.318V10.3977Z",
    fill: "#5A652A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.011 14.7272V10.3977H173.864V14.6591C173.864 16.2613 174.716 17.1818 176.148 17.1818C177.511 17.1818 178.398 16.3636 178.398 14.7272V10.3977H179.25V14.6591C179.25 16.8409 177.989 17.9659 176.114 17.9659C174.273 17.9659 173.011 16.8409 173.011 14.7272Z",
    fill: "#5A652A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0341 24.6135H69.8522V29.0794L74.1477 24.6135H75.2386L72.0341 27.8863L75.375 32.1135H74.3182L71.4545 28.4658L69.8522 30.1022V32.1135H69.0341V24.6135Z",
    fill: "#5A652A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.4205 28.3978C83.4205 26.6933 82.1932 25.2956 80.4887 25.2956C78.7841 25.2956 77.5568 26.6592 77.5568 28.3637V28.3978C77.5568 30.1024 78.7841 31.5001 80.5227 31.5001C82.1932 31.466 83.4205 30.0683 83.4205 28.3978ZM76.6705 28.3978C76.6705 26.3183 78.2046 24.5115 80.4887 24.5115C82.7727 24.5115 84.3068 26.2842 84.3068 28.3637V28.3978C84.3068 30.4433 82.7727 32.2501 80.4887 32.2501C78.2046 32.2501 76.6705 30.4433 76.6705 28.3978Z",
    fill: "#5A652A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.6932 24.6135H87.4773L92.1818 30.6135V24.6135H93.0341V32.1135H92.3523L87.5114 25.9772V32.1135H86.6932V24.6135Z",
    fill: "#5A652A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.193 28.9772V24.6135H104.045V28.909C104.045 30.5113 104.898 31.4317 106.33 31.4317C107.693 31.4317 108.58 30.6135 108.58 28.9772V24.6135H109.432V28.909C109.432 31.0908 108.17 32.2158 106.33 32.2158C104.455 32.2158 103.193 31.0908 103.193 28.9772Z",
    fill: "#5A652A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.807 24.6135H113.659V31.3294H117.886V32.1135H112.807V24.6135Z",
    fill: "#5A652A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.545 25.3976H118.023V24.6135H123.92V25.3976H121.398V32.1135H120.545V25.3976Z",
    fill: "#5A652A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.636 29.3863L128.932 25.5681L127.227 29.3863H130.636ZM127.193 22.9431H130.705V23.6249H127.193V22.9431ZM128.557 24.5795H129.341L132.75 32.1136H131.83L130.943 30.1363H126.886L126 32.1136H125.148L128.557 24.5795Z",
    fill: "#5A652A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.182 28.3978C134.182 26.2501 135.75 24.5115 137.966 24.5115C139.329 24.5115 140.148 24.9887 140.898 25.7047L140.318 26.3183C139.67 25.7387 138.989 25.2956 137.966 25.2956C136.295 25.2956 135.068 26.6251 135.068 28.3637V28.3978C135.068 30.1365 136.329 31.5001 137.966 31.5001C138.989 31.5001 139.67 31.091 140.386 30.4092L140.932 30.9547C140.148 31.7387 139.295 32.2842 137.932 32.2842C135.784 32.2501 134.182 30.5456 134.182 28.3978Z",
    fill: "#5A652A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.739 24.6135H143.591V32.1135H142.739V24.6135Z",
    fill: "#5A652A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.364 30.8863L145.977 30.3749C146.42 31.0567 146.898 31.4317 147.682 31.4317C148.534 31.4317 149.148 30.8181 149.148 29.6249V24.6135H150V29.6249C150 30.5113 149.727 31.159 149.318 31.6022C148.909 32.0113 148.33 32.2158 147.682 32.2158C146.523 32.2158 145.807 31.6703 145.364 30.8863Z",
    fill: "#5A652A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.148 28.9772V24.6135H153V28.909C153 30.5113 153.852 31.4317 155.284 31.4317C156.648 31.4317 157.534 30.6135 157.534 28.9772V24.6135H158.386V28.909C158.386 31.0908 157.125 32.2158 155.284 32.2158C153.409 32.2158 152.148 31.0908 152.148 28.9772Z",
    fill: "#5A652A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.386 28.9772V24.6135H165.239V28.909C165.239 30.5113 166.091 31.4317 167.523 31.4317C168.886 31.4317 169.773 30.6135 169.773 28.9772V24.6135H170.625V28.909C170.625 31.0908 169.364 32.2158 167.489 32.2158C165.648 32.2158 164.386 31.0908 164.386 28.9772Z",
    fill: "#5A652A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.909 24.6135H173.693L178.398 30.6135V24.6135H179.216V32.1135H178.568L173.727 25.9772V32.1135H172.909V24.6135Z",
    fill: "#5A652A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0682 38.8635H69.9205V46.3635H69.0682V38.8635Z",
    fill: "#5A652A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9659 45.784L76.7728 39.6135H72.1023V38.8635H77.9319V39.4431L73.0909 45.5794H77.9319V46.3635H71.9659V45.784Z",
    fill: "#5A652A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5341 42.6476C79.5341 40.568 81.0341 38.7612 83.2841 38.7612C84.5454 38.7612 85.3295 39.1362 86.0795 39.7499L85.534 40.3976C84.9545 39.8862 84.3068 39.5453 83.25 39.5453C81.5795 39.5453 80.4204 40.943 80.4204 42.6135V42.6476C80.4204 44.4203 81.5795 45.7499 83.3863 45.7499C84.2386 45.7499 85.0227 45.409 85.534 44.9999V43.159H83.25V42.409H86.3522V45.3749C85.6704 45.9885 84.6136 46.4999 83.3522 46.4999C81 46.4658 79.5341 44.7612 79.5341 42.6476Z",
    fill: "#5A652A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.4318 38.8635H89.2841V45.5794H93.4773V46.3635H88.4318V38.8635Z",
    fill: "#5A652A"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.3182 38.8636H96.1705V46.3636H95.3182V38.8636ZM93.9887 37.2954H97.5V37.9772H93.9887V37.2954Z",
    fill: "#5A652A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.5 39.6476H97.9773V38.8635H103.875V39.6476H101.352V46.3635H100.5V39.6476Z",
    fill: "#5A652A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.682 38.8636H106.534V46.3636H105.682V38.8636ZM104.386 37.2954H107.898V37.9772H104.386V37.2954Z",
    fill: "#5A652A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.261 45.5794C113.386 45.5794 114.102 45.0681 114.102 44.2499V44.2158C114.102 43.3976 113.42 42.9203 112.125 42.9203H109.773V45.5453H112.261V45.5794ZM111.955 42.2044C112.977 42.2044 113.659 41.7613 113.659 40.8749V40.8408C113.659 40.0908 113.08 39.6135 111.989 39.6135H109.705V42.2044H111.955ZM108.921 38.8635H112.091C112.943 38.8635 113.625 39.1022 114.034 39.5113C114.341 39.8181 114.511 40.2272 114.511 40.7044V40.7385C114.511 41.7272 113.898 42.2044 113.318 42.4772C114.205 42.7499 114.92 43.2613 114.92 44.284V44.3181C114.92 45.6135 113.83 46.3635 112.193 46.3635H108.886V38.8635H108.921Z",
    fill: "#5A652A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.67 43.6023L119.966 39.7841L118.261 43.6023H121.67ZM119.591 38.8296H120.375L123.784 46.3637H122.864L121.977 44.3864H117.92L117.034 46.3637H116.182L119.591 38.8296Z",
    fill: "#5A652A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.943 45.2726L125.455 44.659C126.239 45.3749 126.989 45.7158 128.011 45.7158C129 45.7158 129.682 45.1703 129.682 44.4544V44.4203C129.682 43.7385 129.307 43.3294 127.739 42.9885C126.034 42.6135 125.216 42.0681 125.216 40.8408V40.8067C125.216 39.6476 126.239 38.7612 127.671 38.7612C128.761 38.7612 129.546 39.0681 130.296 39.6817L129.818 40.3294C129.136 39.7499 128.421 39.5112 127.671 39.5112C126.682 39.5112 126.068 40.0567 126.068 40.7044V40.7385C126.068 41.4544 126.443 41.8294 128.114 42.2044C129.784 42.5794 130.534 43.193 130.534 44.318V44.3521C130.534 45.6476 129.477 46.4658 127.977 46.4658C126.818 46.4658 125.83 46.0567 124.943 45.2726Z",
    fill: "#5A652A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.511 42.6476C135.511 40.4999 137.08 38.7612 139.296 38.7612C140.659 38.7612 141.477 39.2385 142.227 39.9544L141.648 40.568C141.034 39.9544 140.318 39.5453 139.296 39.5453C137.625 39.5453 136.398 40.909 136.398 42.6135V42.6476C136.398 44.3862 137.659 45.7499 139.296 45.7499C140.318 45.7499 141 45.3408 141.716 44.659L142.261 45.2044C141.477 45.9885 140.625 46.4999 139.261 46.4999C137.114 46.4658 135.511 44.7953 135.511 42.6476Z",
    fill: "#5A652A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.898 38.8635H149.318V39.6476H144.75V42.2044H148.841V42.9544H144.75V45.5794H149.352V46.3635H143.898V38.8635Z",
    fill: "#5A652A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.261 38.8635H152.045L156.75 44.8635V38.8635H157.568V46.3635H156.886L152.08 40.2272V46.3635H151.261V38.8635Z",
    fill: "#5A652A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.83 39.6476H159.341V38.8635H165.205V39.6476H162.682V46.3635H161.83V39.6476Z",
    fill: "#5A652A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.114 42.6817C171.239 42.6817 172.023 42.1022 172.023 41.1476V41.1135C172.023 40.1931 171.307 39.6476 170.114 39.6476H167.796V42.6817H170.114ZM166.977 38.8635H170.182C171.102 38.8635 171.852 39.1363 172.295 39.6135C172.67 39.9885 172.875 40.4999 172.875 41.0794V41.1135C172.875 42.3408 172.023 43.0908 170.864 43.2953L173.148 46.3635H172.125L169.943 43.4658H167.796V46.3635H166.943V38.8635H166.977Z",
    fill: "#5A652A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.375 45.2726L174.886 44.659C175.67 45.3749 176.42 45.7158 177.443 45.7158C178.432 45.7158 179.114 45.1703 179.114 44.4544V44.4203C179.114 43.7385 178.739 43.3294 177.17 42.9885C175.466 42.6135 174.648 42.0681 174.648 40.8408V40.8067C174.648 39.6476 175.67 38.7612 177.102 38.7612C178.193 38.7612 178.977 39.0681 179.727 39.6817L179.25 40.3294C178.568 39.7499 177.852 39.5112 177.102 39.5112C176.114 39.5112 175.5 40.0567 175.5 40.7044V40.7385C175.5 41.4544 175.875 41.8294 177.545 42.2044C179.216 42.5794 179.966 43.193 179.966 44.318V44.3521C179.966 45.6476 178.909 46.4658 177.409 46.4658C176.25 46.4658 175.295 46.0567 174.375 45.2726Z",
    fill: "#5A652A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLlkc);
export default __webpack_public_path__ + "static/media/logo-llkc.f150340736346bf4d35df902996ea8de.svg";
export { ForwardRef as ReactComponent };